import React from "react";
import { Link } from "react-router-dom";
import TableRows from "../../components/Skeletons/TableRows";
import { useSelector } from "react-redux";

export default function ShowData({ data, loading }) {
  const userLogin = useSelector((state) => state.userLogin);
  const {
    showFilter,
    usersList,
    userIndex,
    setUserId,
    setIsDeleted,
    setModalActiveState,
    setModalEditState,
    setupdateUserConfirm,
    setupdateUser,
    updateUser,
  } = data;
  return (
    <div
      className="tableContainer"
      style={{ height: showFilter ? "63vh" : "23vh" }}
    >
      <table className="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Provider</th>
            <th>Clinic Name</th>
            <th>Email</th>
            <th>User F/L Name</th>
            <th>Birth Date</th>
            <th>Recent Assessments</th>
            <th>Assessments</th>
            <th>Active</th>
            {userLogin?.userInfo?.isclinicadmin && <th>Options</th>}
          </tr>
        </thead>
        <tbody>
          {usersList && !loading ? (
            usersList.length > 0 ? (
              usersList
                .sort((a, b) => a.isDeleted - b.isDeleted) // Sort active (false) first, then deleted (true)
                .map((user, index) => (
                  <tr key={index + 1}>
                    <td>{userIndex + index}</td>
                    <td style={{ textAlign: "left" }}>{user.providerName}</td>
                    <td>{user.clinic}</td>
                    <td>{user.email}</td>
                    <td>
                      {user.patientFirstName + " " + user.patientLastName}
                    </td>
                    <td>
                      {new Date(user.birthDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })}
                    </td>
                    {user.mostRecentAss !== "None" ? (
                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                          whiteSpace: "normal",
                          maxWidth: "130px",
                        }}
                      >
                        <Link
                          to={`/pdfView/${user.assessmentResultId}`}
                          className="table__button2"
                          style={{ marginRight: "0.5rem" }}
                        >
                          <svg
                            className="table__icon primary-icon"
                            style={{ width: "2rem", height: "2rem" }}
                          >
                            <use xlinkHref={`/sprite.svg#icon-pdf`} />
                          </svg>
                          <span>Recent Assessment</span>
                        </Link>
                        <span className="table__iconBox">
                          {user.mostRecentAss}
                        </span>
                      </td>
                    ) : (
                      <td
                        style={{ display: "flex", alignItems: "center" }}
                      ></td>
                    )}

                    <td>
                      <Link
                        to={`/previous-assessments/${user.applicationUserId}`}
                        className="table__btn"
                      >
                        Prev Assessments
                      </Link>
                    </td>

                    <td>
                      <label className="switch">
                        <input
                          id="active"
                          type="checkbox"
                          className="checkbox"
                          checked={!user.isDeleted}
                          onChange={() => {
                            setModalActiveState(true);
                            setUserId(user.applicationUserId);
                            setIsDeleted(user.isDeleted);
                          }}
                          name="active"
                        />
                        <span className="slider round" />
                      </label>
                    </td>

                    {userLogin?.userInfo?.isclinicadmin && (
                      <td>
                        <div className="table__iconBox">
                          <button
                            className="table__button"
                            onClick={() => {
                              setModalEditState(true);
                              setupdateUserConfirm({
                                status: false,
                                newClinic: user.clinicName,
                                oldClinic: user.clinicName,
                                newProvider: user.providerName,
                                oldProvider: user.providerName,
                              });
                              setupdateUser({
                                ...updateUser,
                                userId: user.applicationUserId,
                                fName: user.patientFirstName,
                                lName: user.patientLastName,
                                email: user.email,
                                clinic: user.clinicId,
                                clinicName: user.clinic,
                                provider: user.providerId,
                                EHRId: user.modMedPatientId,
                                MRNId: user.mRNPatientId,
                                IsModMedEnabled: user.isModMedEnabled,
                                IsAthenaEnabled: user.isAthenaEnabled,
                                birthDate:
                                  new Date(user.birthDate).getFullYear() +
                                  "-" +
                                  (
                                    "0" +
                                    (new Date(user.birthDate).getMonth() + 1)
                                  ).slice(-2) +
                                  "-" +
                                  String(
                                    new Date(user.birthDate).getDate()
                                  ).padStart(2, "0"),
                              });
                            }}
                          >
                            <svg className="table__button--icon">
                              <use xlinkHref={`/sprite.svg#icon-edit`} />
                            </svg>
                            <span>Edit User</span>
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))
            ) : (
              <tr>
                <td
                  colSpan="13"
                  style={{ textAlign: "center", padding: "2rem" }}
                >
                  Patient information will be displayed here as they enroll and
                  complete their questionnaires.
                </td>
              </tr>
            )
          ) : (
            <TableRows columns="13" />
          )}
        </tbody>
      </table>
    </div>
  );
}
